module.exports = __webpack_public_path__ + "static/img/banner-center.41a21b8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/cooperation_case/banner-center.png
// module id = MeOp
// module chunks = 0